// src/data/exercises/L5_04.js

const accountOptions = [
  '商品', '仮払消費税', '買掛金', '仮受消費税', '売上原価'];

export const L5_04 = {
  title: '簿記　3級（第214-4回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

      parts: [
    { "type": "ruby", "text": "仕入先", "ruby": "しいれさき" },
    { "type": "text", "value": "から" },
    { "type": "ruby", "text": "商品", "ruby": "しょうひん" },
    { "type": "text", "value": "￥93,500（うち" },
    { "type": "ruby", "text": "消費税額", "ruby": "しょうひぜいがく" },
    { "type": "text", "value": "￥8,500）を" },
    { "type": "ruby", "text": "購入", "ruby": "こうにゅう" },
    { "type": "text", "value": "し、" },
    { "type": "ruby", "text": "代金", "ruby": "だいきん" },
    { "type": "text", "value": "は" },
    { "type": "ruby", "text": "掛", "ruby": "か" },
    { "type": "text", "value": "けとした。ただし、" },
    { "type": "ruby", "text": "当社", "ruby": "とうしゃ" },
    { "type": "text", "value": "は、" },
    { "type": "ruby", "text": "商品", "ruby": "しょうひん" },
    { "type": "ruby", "text": "売買取引", "ruby": "ばいばいとりひき" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "関", "ruby": "かん" },
    { "type": "text", "value": "して、" },
    { "type": "ruby", "text": "販売", "ruby": "はんばい" },
    { "type": "text", "value": "のつど" },
    { "type": "ruby", "text": "売上原価勘定", "ruby": "うりあげげんかかんじょう" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "振", "ruby": "ふ" },
    { "type": "text", "value": "り" },
    { "type": "ruby", "text": "替", "ruby": "か" },
    { "type": "text", "value": "える" },
    { "type": "ruby", "text": "方法", "ruby": "ほうほう" },
    { "type": "text", "value": "（" },
    { "type": "ruby", "text": "売上原価対立法", "ruby": "うりあげげんかたいりつほう" },
    { "type": "text", "value": "）で" },
    { "type": "ruby", "text": "記帳", "ruby": "きちょう" },
    { "type": "text", "value": "している。なお、" },
    { "type": "ruby", "text": "消費税", "ruby": "しょうひぜい" },
    { "type": "text", "value": "を" },
    { "type": "ruby", "text": "税抜方式", "ruby": "ぜいぬきほうしき" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "処理", "ruby": "しょり" },
    { "type": "text", "value": "する。" }
]
      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '商品', debitAmount: 85000, creditAccount: '買掛金', creditAmount:93500 },
        { debitAccount: '仮払消費税', debitAmount: 8500, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '「売上原価勘定に振り替える」→仕入ではなく商品を使います。\n' },
          { type: 'styled', value: '①商品を購入→商品が増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
           { type: 'text', value: '金額は、￥93,500－￥8,500\n' },

          { type: 'text', value: '②消費税額￥8,500→仮払消費税と仮受消費税のどちらかを使う。\n' },
          { type: 'text', value: '商品購入→仮払消費税　　商品販売→仮受消費税　なので、\n' },
          { type: 'styled', value: '仮払消費税を商品とセットで書く借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '③「代金は掛け」→商品の購入の掛けなので、\n' },
          { type: 'styled', value: '買掛金が増加（プラス）貸方（右・Ｃｒ）', color: 'red', bold: true },
        ]

      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
「売上原価勘定に振り替える」→仕入ではなく商品を使います。
①商品を購入→商品が増加（プラス）します。
金額は、￥93,500－￥8,500
②消費税額￥8,500→仮払消費税と仮受消費税のどちらかを使う。
商品購入→仮払消費税　　商品販売→仮受消費税　なので、
仮払消費税を商品とセットで書きます。
③	「代金は掛け」→商品の購入の掛けなので、
買掛金が増加（プラス）します。


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
                  parts: [
          { type: 'text', value: '「売上原価勘定に振り替える」→仕入ではなく商品を使います。\n' },
          { type: 'styled', value: '①商品を購入→商品が増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
           { type: 'text', value: '金額は、￥93,500－￥8,500\n' },

          { type: 'text', value: '②消費税額￥8,500→仮払消費税と仮受消費税のどちらかを使う。\n' },
          { type: 'text', value: '商品購入→仮払消費税　　商品販売→仮受消費税　なので、\n' },
          { type: 'styled', value: '仮払消費税を商品とセットで書く借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '③「代金は掛け」→商品の購入の掛けなので、\n' },
          { type: 'styled', value: '買掛金が増加（プラス）貸方（右・Ｃｒ）', color: 'red', bold: true },
        ]
          }
        ],
       
      },
    },
  ],
};